import { unsafeCSS } from 'lit'
import bootstrap from 'bootstrap/dist/css/bootstrap.min.css?inline'
//import shoelace from '@shoelace-style/shoelace/dist/themes/light.css?inline'

//export { default as stylesPrimer } from '@primer/css/dist/primer.css?inline'

export const stylesBootstrap = unsafeCSS(bootstrap.replaceAll(':root',':host'))


//export const stylesShoelace = unsafeCSS(shoelace)

